import script from "./admin_video.vue?vue&type=script&setup=true&lang=js"
export * from "./admin_video.vue?vue&type=script&setup=true&lang=js"

import "./admin_video.vue?vue&type=style&index=0&id=01e62e17&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01e62e17"]])

export default __exports__